import { TEXTOS } from '../../../lib/glossario'

/**
 * O bloco do quadro, agora no glossário.
 *
 * Este arquivo é só o nome curto que as telas importam. O texto mora em `glossario.ts` pela Regra
 * nº 4: renomear um termo na interface tem de ser mudar uma string, num lugar só.
 */
export const QUADRO = TEXTOS.quadro
